import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import * as XLSX from 'xlsx';
import { FileUploadModule } from 'primeng/fileupload';
import * as Papa from 'papaparse';
import moment from 'moment';
import { LeadService } from 'src/app/private/services/lead.service';
import { MessageService } from 'primeng/api';
import { ColumnInfoComponent } from "../column-info/column-info.component";


@Component({
  selector: 'app-bulk-upload',
  imports: [SharedModule, FileUploadModule, ColumnInfoComponent],
  templateUrl: './bulk-upload.component.html',
  styleUrl: './bulk-upload.component.scss'
})
export class BulkUploadComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Input() users: any = [];
  currentUserId: any = "";
  sheetNames: string[] = [];
  columns: string[] = [];
  @Input() displayedColumns?: any = [];
  workbook: XLSX.WorkBook | null = null;
  mappedColumns: { [key: string]: string } = {}; // Mapping between displayedColumns and Excel columns
  csvData: any = null;
  selectedSheet: string = '';
  selectedSheetName: string = '';
  @Input() lead_space_id: any = ""
  importStatus: boolean = false;
  isLoading: boolean = false;
  @Input() allLeadFeilds: any = [];
  isOpenColumnInfo: boolean = false;
  @Output() reload = new EventEmitter<any>();
  isAdmin: boolean = false;







  constructor(
    private localStorage: LocalStorageService,
    private api: LeadService,
    private messageService: MessageService

  ) {
    this.currentUserId = this.localStorage.getUserId()
    this.isAdmin = this.localStorage.isAdminUser();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['users'] && changes['users'].currentValue != changes['users'].previousValue) {
      this.users = this.users.map((user: any) => {
        return {
          label: user.fname + " " + user.lname,
          value: user?.user_id
        }
      }
      );
    }
  }

  downloadSampleExcel() {
    let col = this.displayedColumns.map((column: any) => this.convertColumnName(column));
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    console.log(col)
    XLSX.utils.sheet_add_aoa(ws, [col]);
    XLSX.utils.book_append_sheet(wb, ws, 'Sample Lead');

    XLSX.writeFile(
      wb,
      'sample_data.xlsx'
    );
  }
  convertColumnName(column: any): string {
    return column?.header
  }

  onFileUpload(event: any): void {
    const target: DataTransfer = <DataTransfer>event.target;
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }

    const file: File = target.files[0];
    const fileType = file.name.split('.').pop()?.toLowerCase();

    if (fileType === 'xlsx') {
      this.processExcelFile(file);
    } else if (fileType === 'csv') {
      this.processCsvFile(file);
    } else {
      throw new Error('Unsupported file type');
    }
  }

  private processExcelFile(file: File): void {
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      this.workbook = XLSX.read(bstr, { type: 'binary' });

      // Extract sheet names
      this.sheetNames = this.workbook.SheetNames;

      console.log('Sheet Names:', this.sheetNames);
      const worksheet = this.sheetNames[0];
      const jsonData = XLSX.utils.sheet_to_json(this.workbook.Sheets[worksheet], { header: 1 });
      this.selectedSheet = this.sheetNames[0];
      // Extract the first row as column names
      this.columns = (jsonData[0] as string[]) || [];

      this.autoColumnMapping();
    };
    reader.readAsBinaryString(file);
  }

  autoColumnMapping(): void {
    this.displayedColumns.forEach((column: any) => {
      if (this.columns.includes(this.convertColumnName(column))) {
        this.mappedColumns[column.field] = this.convertColumnName(column)
      }
    });
  }

  private processCsvFile(file: File): void {
    Papa.parse(file, {
      complete: (result) => {
        const jsonData = result.data;

        // Extract the first row as column names
        this.columns = (jsonData[0] as string[]) || [];

        // Process the rest of the data as needed
        console.log('CSV Data:', jsonData);

        this.csvData = jsonData;

        this.autoColumnMapping();
      },
      header: false, // Adjust based on whether the CSV file has a header row
    });
  }

  onSheetSelect(event: any): void {
    console.log('Selected Sheet:', event?.value);
    const selectedSheet = event.value;
    this.selectedSheetName = selectedSheet;


    if (this.workbook && selectedSheet) {
      const worksheet = this.workbook.Sheets[selectedSheet];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Extract the first row as column names
      this.columns = (jsonData[0] as string[]) || [];
      this.autoColumnMapping();
    }
  }


  onSubmit(): void {
    // Check if a workbook and sheet are selected
    if (!this.sheetNames?.length && !this.csvData) {
      console.error("No workbook, sheet, or CSV data found");
      return;
    }

    let sheetData: any[] = [];

    if (this.workbook) {
      // Handle XLSX file
      const selectedSheetName = this.selectedSheetName || this.sheetNames[0];
      const worksheet = this.workbook.Sheets[selectedSheetName];

      if (!worksheet) {
        console.error("Worksheet not found");
        return;
      }

      // Convert XLSX sheet data to JSON
      sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    } else if (this.csvData) {
      // Handle CSV file
      sheetData = this.csvData;
    }

    // Ensure there is valid sheet data
    if (sheetData.length < 2) {
      console.error("Sheet data is empty or invalid");
      return;
    }

    // Get the header and rows
    const headerRow = sheetData[0]; // First row contains headers
    const dataRows = sheetData.slice(1); // Remaining rows contain data

    // remove empty rows from dataRows
    const filteredDataRows = dataRows.filter((row) => {
      return row.some((cell: any) => {
        const value = cell?.toString().trim();
        return value !== '' && value !== null && value !== undefined;
      });
    });

    console.log('Data Rows:', filteredDataRows);


    // Create an array of mapped data objects
    const mappedData = filteredDataRows.map((row) => {
      const mappedRow: any = {};
      Object.keys(this.mappedColumns).forEach((displayedColumn) => {
        const excelColumn = this.mappedColumns[displayedColumn];
        console.log('Excel Column:', excelColumn);
        if (excelColumn) {
          // Find the index of the Excel column in the header row
          const columnIndex = headerRow.indexOf(excelColumn);
          if (columnIndex > -1) {
            // Map the Excel column value to the displayed column
            mappedRow[displayedColumn] = row[columnIndex];
            // mappedRow['lead_space_id'] = this.lead_space_id;
            mappedRow['organization_id'] = this.localStorage.getOrganizationId();
            mappedRow['user_id'] = this.localStorage.getUserId();
            mappedRow['campus_id'] = this.localStorage.getCampusId();
            mappedRow['assigned_to'] = this.currentUserId;
            mappedRow['lead_time'] = moment().format('HH:mm');
            mappedRow['lead_date'] = moment().format('YYYY-MM-DD');

          } else {
            console.warn(`Column "${excelColumn}" not found in header`);
          }
        }
      });
      return mappedRow;
    });

    let finalData = this.transformLeads(mappedData)

    let removeDataWhichIsTotallyEmpty = finalData.filter((data: any) => {
      return Object.values(data).some(value => value !== null && value !== undefined && value !== '');
    });

    this.handleSubmitData(removeDataWhichIsTotallyEmpty);


  }

  transformLeads(leads: any[]): any[] {
    console.log('Leads:', leads);
    let dynamicFields = this.displayedColumns.filter((column: any) => column.type == 'dynamic_fields')
    console.log('Dynamic Fields:', dynamicFields);
    let transformedLeads = leads.map((lead: any) => {
      let dynamicFieldsData: any = {};
      dynamicFields.forEach((field: any) => {
        dynamicFieldsData[field.field] = lead[field.field];
        delete lead[field.field];
      });

      console.log('Dynamic Fields Data:', dynamicFieldsData);

      return {
        ...lead,
        dynamic_fields: dynamicFieldsData
      };
    });

    console.log('Transformed Leads:', transformedLeads);

    return transformedLeads;
  }


  handleCloseDialog() {
    this.sheetNames = [];
    this.columns = [];
    this.workbook = null;
    this.mappedColumns = {};
    this.csvData = null;
    this.selectedSheet = '';
    this.selectedSheetName = '';
    this.closeDialog.emit();
  }

  handleSubmitData(data: any) {
    this.isLoading = true;
    this.api.createBulkLead(data).subscribe({
      next: (c) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Leads Added Successfully' });
        this.reload.emit();
        this.closeDialog.emit();
      },
      error: (e) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
        this.isLoading = false;
        console.log(e);
      },
      complete: () => { },
    });
  }

  handleOpenColumnInfo() {
    this.isOpenColumnInfo = true;
  }
}
